import { JoonUIColor } from "@joonapp/web-shared"
import { Typography } from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"

import { useRedeemChildRewardModalStore } from "./RedeemChildRewardModal"
import { useCoinsReadyToRedeemQuery } from "../../../networking/quests/queries"

interface CoinsReadyToRedeemCardProps {
  childId: number
  allowRedeem?: boolean
}

const CoinsReadyToRedeemCard = ({
  childId,
  allowRedeem = false,
}: CoinsReadyToRedeemCardProps) => {
  const { data: coinsReadyToRedeem } = useCoinsReadyToRedeemQuery(childId)
  const { onOpen: onOpenRedeemChildsRewardModal } =
    useRedeemChildRewardModalStore()
  const { t } = useTranslation()

  if (!coinsReadyToRedeem) return null

  const handleRedeemNow = () => {
    onOpenRedeemChildsRewardModal()
  }

  return (
    <div className="w-full flex flex-row justify-between px-2 py-3 bg-green-200 rounded-md items-center">
      <div className="flex flex-col gap-[6px]">
        <div className="flex flex-row gap-2 items-center px-1">
          <div className="flex flex-row gap-1 items-center">
            {!allowRedeem && (
              <img
                style={{ width: "12px", height: "12px" }}
                src="/images/icons/coin-icon.png"
                alt="coin"
              />
            )}
            <Typography variant={allowRedeem ? "h3" : "bodyBold"}>
              {coinsReadyToRedeem}
            </Typography>
          </div>
          <Typography variant="bodySmall">
            {t("CT_READY_TO_COLLECT")}
          </Typography>
        </div>
        <div className="flex flex-col gap-[2px]">
          <Typography variant="bodyXSmall" className="px-1">
            {t("CT_CLAIM_FROM_MAILMAN")}
          </Typography>
          {allowRedeem && (
            <button onClick={handleRedeemNow} className="w-fit !p-1">
              <Typography
                variant="bodyXSmall"
                color={JoonUIColor.text.primaryAccent}
                textAlign="left"
                className="w-fit"
              >
                {t("CT_OR_REDEEM_NOW")}
              </Typography>
            </button>
          )}
        </div>
      </div>
      <img
        src="/images/avatars/mailman.png"
        alt="mailman"
        className="w-10 h-10 mr-1"
      />
    </div>
  )
}

export default CoinsReadyToRedeemCard
